export const profileEdit = {
  back: '← マイページへ戻る',
  heading: 'プロフィール編集',
  subtitle: '変更したい項目を編集してください',

  // ラベル
  nameLabel: '名前 *',
  namePlaceholder: 'ニックネームでもOK',
  genderLabel: '性別',
  countryLabel: '居住国',
  countryPlaceholder: '日本',
  timezoneLabel: 'タイムゾーン *',
  nativeLabel: '母語 * （複数選択可）',
  learningLabel: '学習言語 * （複数選択可）',

  // セレクト
  selectPlaceholder: '選択してください',
  genderFemale: '女性',
  genderMale: '男性',
  genderOther: 'その他',

  // バリデーション・状態
  validationRequired: '必須項目を入力してください',
  success: '✅ 保存しました！マイページへ戻ります...',
  saving: '保存中...',
  submit: '変更を保存する',
};
